import { Container } from 'components/atoms';
import { ReactNode } from 'react';
import './DescriptiveInputWrapper.scss';

interface IDescriptiveInputWrapperProps {
  description?: string;
  header: ReactNode[] | ReactNode;
  children?: ReactNode[] | ReactNode;
  headerContent?: ReactNode[] | ReactNode;
  omitContainerContent?: boolean;
}

const DescriptiveInputWrapper = ({
  children,
  description,
  header,
  headerContent,
  omitContainerContent = false,
}: IDescriptiveInputWrapperProps) => {
  return (
    <Container className='self-start w-full max-w-[400px]'>
      <Container.Header
        title={<div className='descriptiveInputWrapper-header'>{header}</div>}>
        {headerContent}
      </Container.Header>
      {omitContainerContent
        ? children
        : children && <Container.Content>{children}</Container.Content>}
      {description && (
        <Container.Content>
          <p className='descriptiveInputWrapper-description'>{description}</p>
        </Container.Content>
      )}
    </Container>
  );
};

export default DescriptiveInputWrapper;
